module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGNsYXNzPSJhY3RpdmUtc2VydmljZS1hcnJvdyIgdmlld0JveD0iMCAwIDkuMjE5IDUuNzUiIHdpZHRoPSI5LjIxOSIgaGVpZ2h0PSI1Ljc1Ij4KICA8cGF0aCBmaWxsPSIjMmQzZTUwIiBjbGFzcz0iYXJyb3ciIGQ9Ik0yMTUuMDMsMzcuNzQ1bC0zLjk2LTQuMzZhMC43NjQsMC43NjQsMCwwLDEsMC0xLDAuNiwwLjYsMCwwLDEsLjkxMiwwbDMuNSwzLjg1OCwzLjUtMy44NThhMC42LDAuNiwwLDAsMSwuOTExLDAsMC43NjIsMC43NjIsMCwwLDEsMCwxbC0zLjk1OSw0LjM2QTAuNiwwLjYsMCwwLDEsMjE1LjAzLDM3Ljc0NVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yMTAuODc1IC0zMi4xODgpIj48L3BhdGg+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dd-arrow.svg
// module id = yb48
// module chunks = 0